"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreamedResults = void 0;

var StreamedResults =
/** @class */
function () {
  function StreamedResults(data, meta) {
    this.$meta = meta;
    this.$data = data;
  }

  Object.defineProperty(StreamedResults.prototype, "rawOutput", {
    /**
     * The raw output from the importer including all deleted rows
     * and sequence info
     */
    get: function get() {
      return this.$data;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StreamedResults.prototype, "data", {
    /**
     * An array of valid data, key-mapped to the configuration provided
     * (alias of validData)
     */
    get: function get() {
      return this.validData;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StreamedResults.prototype, "validData", {
    /**
     * An array of valid data, key-mapped to the configuration provided
     */
    get: function get() {
      return this.$data.filter(function (v) {
        return v.valid;
      }).filter(function (v) {
        return !v.deleted;
      }).map(function (v) {
        return v.data;
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StreamedResults.prototype, "deletedData", {
    /**
     * Rows of data the user excluded from the final results,
     * key-mapped to the configuration provided
     */
    get: function get() {
      return this.$data.filter(function (v) {
        return v.deleted;
      }).map(function (v) {
        return v.data;
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StreamedResults.prototype, "allData", {
    /**
     * All data from the original file upload including deleted rows,
     * key-mapped to the configuration provided
     */
    get: function get() {
      return this.$data.map(function (v) {
        return v.data;
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StreamedResults.prototype, "remainingChunks", {
    /**
     * The number of remaining chunks in the stream
     */
    get: function get() {
      return Math.ceil((this.totalChunks - this.currentChunk) / this.$meta.inChunks);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StreamedResults.prototype, "totalChunks", {
    /**
     * The total number of chunks that will have to be received before data processing is completed
     */
    get: function get() {
      return Math.ceil(this.$meta.count_rows_accepted / this.$meta.inChunks);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StreamedResults.prototype, "chunkSize", {
    /**
     * The size of chunks as configured when requesting data.
     */
    get: function get() {
      return this.$meta.inChunks;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StreamedResults.prototype, "currentChunk", {
    /**
     * The current chunk by index
     */
    get: function get() {
      return (this.$meta.pointer + this.chunkSize) / this.chunkSize;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StreamedResults.prototype, "hasMore", {
    /**
     * The current chunk by index
     */
    get: function get() {
      return this.$meta.hasMore;
    },
    enumerable: false,
    configurable: true
  });
  return StreamedResults;
}();

exports.StreamedResults = StreamedResults;